import { render, staticRenderFns } from "./vectorHardware.vue?vue&type=template&id=b309ddb0&scoped=true"
import script from "./vectorHardware.vue?vue&type=script&lang=js"
export * from "./vectorHardware.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b309ddb0",
  null
  
)

export default component.exports